/***
 * @file:
 * @author: haoxianhuan
 * @Date: 2021-08-14 14:40:39
 */

import { I } from '@angular/cdk/keycodes';
import { AfterViewInit, Component, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import Quill from 'quill';
import ImageResize from 'quill-image-resize';
import { ControlValueAccessorService } from '../../control-value-accessor.service';

@Component({
  selector: 'dt-editor-rich',
  templateUrl: './editor-rich.component.html',
  styleUrls: ['./editor-rich.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EditorRichComponent),
      multi: true,
    },
  ],
})
export class EditorRichComponent extends ControlValueAccessorService implements AfterViewInit {
  @ViewChild('editorHtmlComponentRef', { static: false }) editorHtmlComponentRef: any;
  @ViewChild('htmlComponentRef', { static: false }) htmlComponentRef: any;
  @Input() placeholder = '';
  @Input() readOnly = false;
  @Input() itemClass = '';
  @Input() maxl = 0;
  @Input() prop = '';
  @Input() set disabled(isDisabled) {
    this.isDisabled = isDisabled;
    this.setDisabled();
  }
  @Input() set content(value) {
    this.currentValue = value;
    this.initValue();
  }
  @Input() modules = {
    toolbar: [
      [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      ['image', 'link'],
      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      ['blockquote'],
      [{ align: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
    ],
    imageResize: {
      modules: ['Resize', 'DisplaySize', 'Toolbar'],
    },
  };
  @Output() editorChanged = new EventEmitter<string>();
  @Output() editorCreated = new EventEmitter<string>();
  @Output() valueChange = new EventEmitter<string>();
  @Output() selectionChanged = new EventEmitter<string>();
  @Output() focus = new EventEmitter<string>();
  isLoad = false;
  currentValue = '';
  isDisabled = false;
  constructor() {
    super();
    Quill.register('modules/imageResize', ImageResize);
  }
  ngAfterViewInit() {
    this.isLoad = true;
    this.initValue();
  }
  initValue() {
    if (this.isLoad) {
      this.editorHtmlComponentRef.writeValue(this.currentValue);
      this.setDisabled();
    }
  }
  setDisabled() {
    if (this.isLoad && this.isDisabled && this.htmlComponentRef) {
      this.htmlComponentRef.nativeElement.innerHTML = this.currentValue;
    }
  }
  onEditorCreated(event) {
    this.editorCreated.emit(event);
  }
  onContentChanged(event) {
    this.writeValue(event.html);
    this.valueChange.emit(event.html);
  }
  onSelectionChanged(event) {
    this.selectionChanged.emit(event);
  }
  onEditorChanged(event) {
    this.editorChanged.emit(event);
  }
  onFocus(event) {
    this.focus.emit(event);
  }
}
